<template>
    <div class="rounded-md bg-yellow-50 border border-t-yellow-800 border-t-4 border-yellow-400 p-4 shadow-md">
        <div class="flex">
            <div class="flex-shrink-0">
                <font-awesome-icon :icon="faCircleInfo" class="h-5 w-5 text-yellow-800" aria-hidden="true" />
            </div>
            <div class="ml-3">
                <div class="text-sm text-yellow-800">
                    <p class="font-bold">This municipality or jurisdiction has a two-step process used to verify tenants.</p>
                    <p class="mt-2">Step one, a real estate agent or landlord may check a prospective tenant’s credit score, income, and rental history to see if they prequalify.</p>
                    <p class="mt-2">Step two, only after the real estate agent or landlord prequalifies a prospective tenant through the above step and chooses to proceed, a criminal background or eviction history screening may then be conducted.</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {
    faCircleInfo,
} from "@fortawesome/pro-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
</script>
